import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { LinkText } from '@/components/ui/Typography/Body/LinkText';
import { Text } from '@/components/ui/Typography/Body/Text';
import { professionalUnitPath } from '@/utils/router/links';
export const RfpClientCompany = (props) => {
    const { className = '', companyName, urlCode } = props;
    if (!urlCode) {
        return (_jsx(Text, Object.assign({ className: className, color: 'base', size: 'sm' }, { children: companyName })));
    }
    return (_jsx(RouterLink, Object.assign({ className: clsx('group', className), target: '_blank', to: professionalUnitPath(urlCode) }, { children: _jsx(LinkText, Object.assign({ isGroup: true, size: 'sm' }, { children: companyName })) })));
};
